// removed by extract-text-webpack-plugin
module.exports = {"i_symbol":"src-components----Info-module---i_symbol---3FNh4","i_circle":"src-components----Info-module---i_circle---3f-x-","i_popup":"src-components----Info-module---i_popup---3X9YC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Info.module.css
// module id = 613
// module chunks = 168707334958949